import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import CardSystem, { getCardHandler } from '../../Card/CardSystem';
import BaseCardHandler from '../../Card/Handler/BaseCardHandler';
import { CARD_STACK_OFFSET } from '../../../Constants/InGame';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import CardComponent, { DEFAULT_CARD_SCALE } from 'Component/Level/Card';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';

export class UndoFold extends AnimationClip {
    public* execute(
        gameObject: BaseCard,
        meta: {
            system: CardSystem;
        },
    ): IterableIterator<number> {
        StreakBar.instance.update({ isUndo: true });

        const cardComponent = gameObject.getComponent(CardComponent);
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent,
        );
        const handler: BaseCardHandler = getCardHandler(gameObject);

        const tweenX = this.getTween(transform.position);
        tweenX
            .to(
                {
                    x: CARD_STACK_OFFSET,
                    y: 0,
                },
                300,
            )
            .easing(Easing.Quadratic.InOut)
            .start(this.elapsedTime);

        const tweenIn = this.getTween(transform.scale);
        tweenIn.to({ x: 0 }, 150).easing(Easing.Quadratic.In);

        cardComponent.skipStackAlign = true;
        meta.system.cardStack.align();

        yield* this.startTween(tweenIn);

        handler.setCardFaceUp(false);

        cardComponent.skipStackAlign = false;
        meta.system.cardStack.align();

        const tweenOut = this.getTween(transform.scale);
        tweenOut.to({ x: DEFAULT_CARD_SCALE }, 150).easing(Easing.Quadratic.Out);

        // Not yielded...
        yield* this.startTween(tweenOut);
    }
}
